import { TrackingContext, linkClicked } from '@ps/web-shared-analytics';
import type { MyBet } from '@ps/web-sports-api-types';
import { useContext, useMemo } from 'react';

import { getEntities } from '../../../../../../../utils/getEntities';

interface TrackPromotionHistory {
  bet: MyBet;
  destinationUrl: string;
}

const linkText = 'Promotion History';

const useTrackPromotionHistory = () => {
  const trackingContext = useContext(TrackingContext);

  const trackPromotionHistory = useMemo(
    () =>
      ({ bet, destinationUrl }: TrackPromotionHistory) => {
        const entities = getEntities(bet);
        linkClicked({ ...trackingContext, entities }, { linkText, destinationUrl });
      },
    [trackingContext]
  );

  return trackPromotionHistory;
};

export default useTrackPromotionHistory;
